var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8444 9.42315C13.6381 9.42315 13.4708 9.59038 13.4708 9.79672V13.1137C13.4701 13.7324 12.9688 14.2338 12.3501 14.2344H1.86789C1.24915 14.2338 0.747885 13.7324 0.747155 13.1137V3.37863C0.747885 2.76004 1.24915 2.25863 1.86789 2.2579H5.18485C5.39119 2.2579 5.55843 2.09066 5.55843 1.88432C5.55843 1.67812 5.39119 1.51074 5.18485 1.51074H1.86789C0.836756 1.51191 0.00116743 2.3475 0 3.37863V13.1138C0.00116743 14.145 0.836756 14.9806 1.86789 14.9817H12.3501C13.3812 14.9806 14.2168 14.145 14.218 13.1138V9.79672C14.218 9.59038 14.0508 9.42315 13.8444 9.42315Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0713 0.549041C13.4147 -0.107493 12.3503 -0.107493 11.6938 0.549041L5.02893 7.2139C4.98325 7.25958 4.95027 7.3162 4.93305 7.37836L4.0566 10.5425C4.02056 10.6723 4.05718 10.8112 4.15233 10.9065C4.24762 11.0016 4.38655 11.0383 4.51628 11.0024L7.68045 10.1258C7.74262 10.1085 7.79924 10.0756 7.84491 10.0299L14.5096 3.36488C15.1651 2.70791 15.1651 1.64438 14.5096 0.987411L14.0713 0.549041ZM5.84292 7.45673L11.2976 2.00191L13.0568 3.76108L7.60194 9.2159L5.84292 7.45673ZM5.49152 8.16185L6.89696 9.56744L4.9529 10.1061L5.49152 8.16185ZM13.9814 2.83662L13.5852 3.23282L11.8259 1.4735L12.2222 1.0773C12.5869 0.712627 13.1782 0.712627 13.5429 1.0773L13.9814 1.51567C14.3455 1.88079 14.3455 2.47165 13.9814 2.83662Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGrayIcon);
export default __webpack_public_path__ + "static/media/edit-gray-icon.c817ca3f5cef7facf1a18827a28ccf89.svg";
export { ForwardRef as ReactComponent };